import { boolean, object, string } from 'yup';

export const joinAsyncTournamentValidationSchema = (withPassphrase: boolean) => {
  return object().shape({
    passphrase: withPassphrase ? string().required().min(8) : string(),
    isRewardBalanceSelected: boolean().optional(),
  });
};
